import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function Hero() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '40%']);
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <section ref={ref} className="relative h-screen w-full overflow-hidden bg-ivory flex items-center" data-id="element-50" data-mp="128z0cez35zzp">
      {/* Parallax Background Image */}
      <motion.div style={{
      y
    }} className="absolute inset-0 w-full h-full" data-id="element-51" data-mp="sarsclmrys9u">
        <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=1920&q=80" alt="Sonrisa perfecta" className="w-full h-full object-cover object-center" data-id="element-52" data-mp="nb6njukxbpp7" />
        {/* Light scrim so the copy stays readable over the photo */}
        <div className="absolute inset-0 bg-ivory/40" data-id="element-53" data-mp="3j7zc59vbxccg" />
        <div className="absolute inset-0 bg-gradient-to-r from-ivory via-ivory/80 to-transparent" data-id="element-54" data-mp="3j6fx1mlet7c9" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-ivory to-transparent" data-id="element-55" data-mp="3o5j2h85axfkr" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 md:px-12 w-full pt-20" data-id="element-56" data-mp="3e8mtz2fektg7">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-57" data-mp="30iaz4vrfogld">
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-ink leading-[1.05] mb-6" data-id="element-58" data-mp="2vi55ja1lsk0n">
            El Arte de una <br data-id="element-59" data-mp="2hkgj3xrw14th" />
            <span className="text-gold-deep italic" data-id="element-60" data-mp="2hjyp77sp72oq">Sonrisa Impecable</span>
          </h1>

          <p className="font-sans text-lg md:text-xl text-ink-soft mb-10 max-w-xl font-light leading-relaxed" data-id="element-61" data-mp="2lk8usjckvr32">
            Tecnología dental avanzada diseñada para quienes no se conforman con
            menos. Experimenta la odontología de élite.
          </p>

          <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.04
        }} whileTap={{
          scale: 0.97
        }} transition={{
          duration: 0.16,
          ease: [0.23, 1, 0.32, 1]
        }} className="inline-block bg-gold text-ink px-8 py-4 rounded-sm font-semibold text-sm md:text-base uppercase tracking-widest hover:bg-gold-deep hover:text-white transition-colors shadow-[0_8px_24px_rgba(201,162,39,0.28)]" data-id="element-62" data-mp="ibp02q9eowx0">
            Reservar Sesión VIP
          </motion.a>
        </motion.div>
      </div>
    </section>;
}